module.exports = __webpack_public_path__ + "img/fa6d601623ef51e9dc0063a2fefce238.png";